import {SEARCHED_DETAILS, SELECT_JUMP_SEAT, VERIFY_INTERNATIONAL_DOCUMENT, PRINTER_POPUP_SEARCH_PAGE, INITIAL_BAGGAGE_COUNT } from './SearchType'
import {BAG_ADDED, SELECT_LRT_BAGTYPE} from '../Bags/BagType'

export const searchCredential=(props)=>
{
    // debugger;  
    return{
        type:SEARCHED_DETAILS,
        SearchedRecordData:props.SearchedRecordData,
        SearchedFlightDetails:props.SearchedFlightDetails
    }
}

export const bagCredential=(props)=>
{
    return{
        type:BAG_ADDED,
        isBagAdded:props.isBagAdded,
    }
}

export const jumpSeatCredential = (props) => {
    return {
        type: SELECT_JUMP_SEAT,
        isJumpSeatSelected: props.isJumpSeatSelected
    }
}

export const verifyInternationalDocumentCredential = (props) => {
    return {
        type: VERIFY_INTERNATIONAL_DOCUMENT,
        isInternationalDocumentVerified: props.isInternationalDocumentVerified
    }
}

export const lrtBagTypeCredential = (props) => {
    return {
        type: SELECT_LRT_BAGTYPE,
        lrtBagTypeForPassenger: props.lrtBagTypeForPassenger
    }
}

export const printerPopupSearchPageCredential = (props) => {
    return {
        type: PRINTER_POPUP_SEARCH_PAGE,
        isPrinterPopupSearchPageOpen: props.isPrinterPopupSearchPageOpen
    }
}

export const initialBaggageCountCredentials = (props) => {
    return {
        type: INITIAL_BAGGAGE_COUNT,
        initialBaggageCount: props.initialBaggageCount
    }
}